import ReactMarkdown from "react-markdown";

import { formatVendorMarkdown } from "../utils/vendorsHelper";

export default function Vendor({ vendor }) {
	return <ReactMarkdown>{formatVendorMarkdown(vendor)}</ReactMarkdown>;
}
